"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = exports.checkCookieRestriction = void 0;
var checkCookieRestriction = function checkCookieRestriction(restriction) {
  if (!restriction) {
    return true;
  }
  return typeof document !== 'undefined' && getCookie(restriction.cookieName) === restriction.value;
};
exports.checkCookieRestriction = checkCookieRestriction;
var getCookie = function getCookie(cookieName) {
  if (typeof 'document' === 'undefined') {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + cookieName + '=');
    if (parts.length == 2) return parts.pop().split(';').shift();
  }
};
exports.getCookie = getCookie;
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static-plugin-google-tag-manager/dist/helpers.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static-plugin-google-tag-manager/dist/helpers.js");
  }
}();